import { Component, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MustMatch } from '@app/_helpers';
import { PatternValidator } from '@app/_helpers/pattern.validator';
import { AccountService, AlertService } from '@app/_services';
import { environment } from '@environments/environment';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css'],
    standalone: true,
    imports: [NgClass, ReactiveFormsModule]
})
export class ChangePasswordComponent implements OnInit {
  account = this.accountService.accountValue;
  form: UntypedFormGroup;
  loading = false;
  submitted = false;
  deleting = false;

  constructor(
      private formBuilder: UntypedFormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private accountService: AccountService,
      private alertService: AlertService
  ) { }

  ngOnInit() {
    // const regex = new RegExp(/[^A-Za-z 0-9]/g);
    //const specialCharactersRegex = new RegExp(/[~`!#$%\^&*+=\-\[\]\\';,\/{}|\\":<>\?]/g);
    const specialCharactersRegex = new RegExp(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/);
    const whitespaceRegex = new RegExp(/[\r\n\t\f\v ]/g);
      this.form = this.formBuilder.group({
        password: ['', [
            // 1. Password Field is Required
                Validators.required,
                // 2. check whether the entered password has a number
                PatternValidator(/\d/, { hasNumber: true }),
                // 3. check whether the entered password has upper case letter
                PatternValidator(/[A-Z]/, { hasUpperCase: true }),
                // 4. check whether the entered password has a lower-case letter
                PatternValidator(/[a-z]/, { hasLowerCase: true }),
                // 5. check whether the entered password has a special character
                PatternValidator(specialCharactersRegex, { hasSpecialCharacters: true }),
                // 6. Has a minimum length of 8 characters
                Validators.minLength(8),
                // 7. Has a maximum length of 14 characters
                Validators.maxLength(14)
                // 8. Has any spaces or whitespace
                // PatternValidator(whitespaceRegex, { hasSpaces: true })
            ]
        ],
          confirmPassword: ['']
      }, {
          validator: MustMatch('password', 'confirmPassword')
      });
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
      this.submitted = true;

      // reset alerts on submit
      this.alertService.clear();

      // stop here if form is invalid
      if (this.form.invalid) {
          return;
      }

      this.loading = true;
      this.accountService.changePassword(this.account.id, this.form.value)
          .pipe(first())
          .subscribe({
              next: () => {
                  this.alertService.success('Password change successful', { keepAfterRouteChange: true });
                  window.location.href = environment.appBaseUrl;
              },
              error: error => {
                  this.alertService.error(error);
                  this.loading = false;
              }
          });
  }

}
